export const CONFIG = {
  API_URL: process.env.REACT_APP_EXT_API_URL ? process.env.REACT_APP_EXT_API_URL : 'https://directory-wolverhampton.ddev.site',
  FILES_LOCATION: '/sites/default/files',
  ADD_ORG_NODE_FORM: '/node/add/organisations',
  ORG_PATH: '/api/node/organisations',
  ORG_LOGO: '/api/organisations/logo',
  COMMENTS_PATH: '/api/comment/reviews',
  AGE_RANGE: '/api/taxonomy_term/age_range',
  INDUSTRY: '/api/taxonomy_term/industry',
  SHOW_ITEMS_NUMBER: 9,
  MAP_INITIAL_LOCATION: {
    lat: 52.591337388178154,
    lng: -2.124875747222319
  }
};
